import React from 'react'

export default function () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox="0 0 23.813 22.728"
    >
      <path
        fill="#00a396"
        fillRule="evenodd"
        d="M7.71 1.939a.722.722 0 0 1 .387.945l-.202.48 1.803.276a9.386 9.386 0 0 1 5.694 3.162l.076.088a7.942 7.942 0 0 0 4.71 2.658l3.033.51a.722.722 0 0 1 .512 1.06 46.002 46.002 0 0 0-3.849 9.177.722.722 0 0 1-.812.507l-3.037-.51a9.386 9.386 0 0 1-5.566-3.14l-.076-.089a7.942 7.942 0 0 0-4.817-2.675l-2.16-.333-2.018 4.807a.722.722 0 0 1-1.332-.56l6.71-15.977a.722.722 0 0 1 .944-.386Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        stroke="#00a396"
        strokeLinejoin="round"
        strokeWidth="3.969"
        d="M6.914 22.625h13.308l-1.931-2.54h-5.557l4.366-5.054c1.693-1.957 2.831-2.963 2.831-5.45 0-3.07-2.487-5.715-6.165-5.715-3.73 0-6.191 2.858-6.191 6.377h3.016c0-1.932 1.19-3.731 3.175-3.731 1.879 0 3.07 1.35 3.07 3.07 0 1.401-.9 2.46-2.302 4.1z"
        aria-label="2"
        paintOrder="stroke fill markers"
        transform="translate(-1.323 -1.882)"
      />
    </svg>
  )
}
